module.exports = __webpack_public_path__ + "fa04d70e485a789b3f3cb65ec84eb4c5-SafeExcavatorHero.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/assets/SafeExcavatorHero.png
// module id = 595
// module chunks = 0